<template>
  <div class="auth">
    <div class="box">
      <img class="logo" src="../../assets/img/login-logo.png">
      <p class="title text-center bold">Login Ugift</p>
      <div class="login-btn bold fx fx-center fx-items-center" @click="loginFb">
        <img class="fb" src="../../assets/img/login-fb.jpg">
        <span>Connect with Facebook</span>
      </div>
      <p class="tips text-center">Note: Please Disable the "Block Pop-ups" in Your Browser Settings if Facebook Page Can Not be Opened</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      timer: null,
      goodsId: '',
      memberId: '',
      picture: '',
      name: '',
      orderId: '',
      listId: '',
      type: '',
      loginParams: {
        password: '',
        phone: '',
        country: '',
        bindingAccount: '',
        platformName: 'facebook'
      }
    }
  },
  created () {
    const queryParams = this.$route.query

    this.goodsId = queryParams.goodsId
    this.memberId = queryParams.memberId
    this.picture = queryParams.picture
    this.name = queryParams.name
    this.orderId = queryParams.orderId
    this.listId = queryParams.listId
    this.type = queryParams.type
  },
  beforeDestroy () { // 组件销毁前调用
    clearTimeout(this.timer)
  },
  methods: {
    // 登录
    newOlvpLogin (params) {
      return this.$http.post('/olvp/newOlvpLogin', 'newOlvpLogin', params)
    },
    thirdLogin (fbId, picture, name) {
      this.loginParams.bindingAccount = fbId
      this.newOlvpLogin(this.loginParams).then((d) => {
        if (d.success) {
          if (d.content.success === 'true') {
            if (d.content.phone) {
              this.$util.storageSet('local', 'phone', d.content.phone)
            }
            this.$util.storageSet('local', 'facebookId', fbId)
            this.$util.storageSet('local', 'platform', this.$route.query.platformName)
            this.$util.storageSet('local', 'token', d.content.token)
            this.$util.storageSet('local', 'picture', picture)
            this.$util.storageSet('local', 'name', name)
            if (this.$route.query.backPath) {
              this.$router.replace(this.$route.query.backPath)
            } else {
              this.backHome()
            }
          } else {
            // 新用户未绑定手机
            if (d.content.message === 'APP_OLVP_BOUND_ERROR') {
              this.$router.replace(`register?platform=facebook&fbId=${fbId}&backPath=${this.$route.query.backPath}`)
            }
          }
        } else {
        }
      })
    },
    loginFb () {
      window._czc.push(['_trackEvent', '点击', 'facebook授权'])
      // id: "223366525765140"
      this.$cux.loading()
      this.timer = setTimeout(() => {
        this.$cux.loadend().then(() => {
          this.$cux.toast('Cannot connect to Facebook. Please check browser settings or refresh to retry.')
        })
      }, 10000)
      this.$facebook.checkFB().then(() => { // FB对象初始化
        /* eslint-disable no-undef */
        FB.getLoginStatus((response) => {
          console.log('status:' + response.status) // 检测Facebook的登录状态
          if (response.status === 'connected') {
            FB.api('/me', {
              fields: 'name,email,picture'
            }, (response) => {
              this.$cux.loadend().then(() => {
                const picture = response.picture.data.url || 'https://ebuyimg.e-mallchina.com/olvp/logo.png'
                this.$util.storageSet('local', 'facebookId', response.id)
                this.$util.storageSet('local', 'name', response.name)
                this.$util.storageSet('local', 'picture', picture)
                this.thirdLogin(response.id, picture, response.name)
              })
            })
          } else {
            FB.login((response) => {
              console.log('login:' + response.status)
              if (response.status === 'connected') {
                FB.api('/me', {
                  fields: 'id,name,email,picture'
                }, (response) => {
                  this.$cux.loadend().then(() => {
                    const picture = response.picture.data.url || this.$util.storageGet('local', 'picture')
                    this.$util.storageSet('local', 'facebookId', response.id)
                    this.$util.storageSet('local', 'name', response.name)
                    this.$util.storageSet('local', 'picture', picture)
                    this.thirdLogin(response.id, picture, response.name)
                  })
                })
              } else {
                this.$cux.loadend()
              }
            }, {
              scope: 'public_profile,email'
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
  .auth {
    width: 100%;
    height: 100%;
    background: url('../../assets/img/login.jpg') no-repeat;
    background-size: cover;
    text-align: center;
    position: relative;

    .box {
      width: 100%;
      padding: 20px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      .logo {
        width: 110px;
        height: 110px;
        margin: 0 auto;
      }

      .title {
        color: #fff;
        font-size: 16px;
        margin-top: 15px;
        margin-bottom: 60px;
      }

      .login-btn {
        width: 100%;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 4px;
        padding: 12px;
        font-size: 15px;
        .fb {
          width: 25px;
          height: 25px;
          margin-right: 10px;
        }
      }

      .tips {
        color: #fff;
        margin-top: 30px;
        font-size: 13px;
      }

      .back {
        color: #fff;
        margin-top: 30px;
        text-decoration: underline;
      }
    }
  }
</style>
